import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AuthCallback() {
  const navigate = useNavigate();
  useEffect(() => {
    // Supabase session URL'den otomatik okunur
    // Android app'e token gönder
    if (window.AndroidBridge && window.location.hash) {
      window.AndroidBridge.onAuthCallback(window.location.href);
    }
    setTimeout(() => navigate("/"), 1000);
  }, []);
  return (
    <div style={{ minHeight: "100vh", background: "#0a0718", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 40 }}>
      🔮
    </div>
  );
}
